<template>
  <!-- 邀请人员 -->
  <div class="deviceInfo">
    <el-form-item :prop="'list.' + index + '.phone'" :rules="deviceInfo.rules.telephone" :ref="'list.' + index + '.phone'" label="" >
      <el-input
        v-model="deviceInfo.phone"
        clearable
        placeholder="请输入手机号,必填"
        maxlength="20"
        size="small"
        @focus="addDriver(index)"
      ></el-input>
    </el-form-item>
    <el-form-item :ref="'list.' + index + '.specRole'" :prop="'list.' + index + '.specRole'" :rules="deviceInfo.rules.specRole1" label="" v-if="type===2">
      <el-cascader
        :props="specRoleDefaultProps"
        size="small"
        v-model="deviceInfo.specRole"
        placeholder="请选择所属角色,必填"
        :options="specRoleList">
      </el-cascader>
    </el-form-item>
    <el-form-item :ref="'list.' + index + '.neiwaibu'" :prop="'list.' + index + '.neiwaibu'" :rules="deviceInfo.rules.neiwaibu1" label="" >
      <el-select
        disabled
        v-model="deviceInfo.neiwaibu"
        placeholder="请选择人员类别,必填"
        clearable
        size="small"
        filterable
      >
        <el-option
          v-for="item in DEVICE_BRAND"
          :key="item.item"
          :label="item.item"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :prop="'list.' + index + '.bumen'" label="" :rules="deviceInfo.rules.bumen" :ref="'list.' + index + '.bumen'">
      <el-input
        v-model="deviceInfo.bumen"
        :title="deviceInfo.bumen"
        clearable
        :placeholder="addType === '0' ? '请选择部门' : '请选择供方公司'"
        readonly
        size="small"
        @focus="changebumen(index)"
      ></el-input>
    </el-form-item>
    <el-form-item v-if="list.length > 1" label="">
      <p style="color:#FF5454" @click="removeComponent">删除</p>
    </el-form-item>
    <el-dialog
      v-dialogDrag
      :visible.sync="departmentVisible"
      v-if="departmentVisible"
      :before-close="departmentClose"
      :title="addType === '0' ? '部门' : '供方公司'"
      width="30%"
      class="people_class"
    >
      <div class="bottom_left">
        <departmentTree ref="departmentTree" @depChange="currentDepChangeHandler" :addType="addType"></departmentTree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="departmentClose">取 消</el-button>
        <el-button size="small" type="primary" @click="departmentselsetBtn"
        >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import departmentTree from "@/views/supperson/components/departmentTree/departmentTree"
import docService from "@/CommonDP/service/doc-service";
import prjMemberService from '@/xgzdService/prjMember-service'
import { mapState } from "vuex";

export default {
  props: {
    index: { default: 0, type: Number },
    list: { type: Array, required: true },
    deviceInfo: { type: Object, required: true },
    type:{ default: 0, type: Number },     // 1 企业 2项目
    addType:{ default: '0', type: String}
  },
  components:{departmentTree},
  data() {
    return {
      DEVICE_BRAND: [
        {
          item: '内部',
          id: '0'
        },
        {
          item: '外部',
          id: '1'
        }
      ],
      departmentVisible: false,
      currentDepartment: {},
      specRoleList:[],
      specRoleDefaultProps: {
        children: "childList",
        label:'roleName',
        value:"roleID",
      },
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
    }),
  },
  created() {
    if(this.type===2){
      //内部角色
      if (this.addType === '0') {
        this.queryInteriorRole()
      } else {
        //外部角色
        this.queryExternalRole()
      }
    }
  },
  methods: {
    async querySpecRoleList(){
      const { prjId } = this.prjInfo;
      const result = await docService.queryRoleList(prjId, this.enterpriseId);
      result.data.map(item =>{
        // 为了保持名称一致 获取的时候好获取
        item.roleName=item.specName;
        item.roleId=item.specId;
      })
      this.specRoleList=result.data;
    },

    async queryInteriorRole () {
      const { prjId } = this.prjInfo;
      const result = await prjMemberService.queryInteriorTree(prjId);
      this.specRoleList = result.data;
    },

    async queryExternalRole () {
      const { prjId } = this.prjInfo;
      const result = await prjMemberService.queryExternalTree(prjId);
      this.specRoleList = result.data;
    },

    removeComponent() {
      this.$emit('removeComponent', this.index)
    },
    addDriver(index) {
      this.$emit('addComponent', index)
    },
    changebumen(index) {
      this.departmentVisible = true;
    },
    departmentClose() {
      this.departmentVisible = false;
      this.currentDepartment = {};
    },
    departmentselsetBtn() {
      this.departmentVisible = false;
      this.deviceInfo.bumen = this.currentDepartment.deptName;
      this.deviceInfo.bumenid = this.currentDepartment.deptId;
    },
    currentDepChangeHandler(val) {
      this.currentDepartment = val;
    }
  }
};
</script>
<style  lang="scss">
.people_class{
  .el-dialog__body{
    height: 300px;
  }
}
</style>
<style lang="scss" scoped>
.deviceInfo {
  .el-textarea__inner {
    width: 420px;
  }
  .remove {
    color: #fafafa;
    background: #f56c6c;
    border-color: #f56c6c;
  }
  .el-input__inner{
    width: 210px!important;
  }
  .el-form-item{
    margin-bottom:15px!important;
    /deep/ .el-form-item__content{
      height: 40px!important;
    }
  }
  .bottom_left{
    height: 100%;
    overflow :auto
  }
}
</style>
